/**
 * Created by wafer on 2017/5/22.
 */

import request from '../utils/request';
import _ from 'lodash';

export const myReservationLists = params => {
  let uri = '/smartmeeting/smart/third/findMyMeetings';
  Object.keys(params).forEach(key => {
    if (uri.indexOf('?') == -1) {
      uri += `?${key}=${_.trim(params[key])}`;
    } else {
      uri += `&${key}=${_.trim(params[key])}`;
    }
  });
  return request(uri);
};
export const meetingSign = ({ meetingId, userId, locale }) => {
  const uri =
    '/smartmeeting/smart/third/signIn?meetingId=' +
    meetingId +
    '&userId=' +
    userId +
    '&lang=' +
    locale;
  return request(uri);
};
export const getExternal = locale => {
  return request(`/iwork/external/getAllUser?lang=${locale}`);
};
export const closeMeeting = ({ meetingId, locale }) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  const userId = userInfo.userId + '@' + userInfo.domainName;
  const url = `/smartmeeting/smart/board/end?lang=${locale}&meetingId=${meetingId}&userId=${userId}`;
  return request(url);
};

export const meetingSignOut = ({ meetingId, userId, locale }) => {
  const uri =
    '/smartmeeting/smart/board/end?meetingId=' +
    meetingId +
    '&userId=' +
    userId +
    '&lang=' +
    locale;
  return request(uri);
};
export const cancelMeeting = ({ meetingId, type, locale }) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  const uri =
    '/smartmeeting/smart/third/cancelMeeting?lang=' +
    locale +
    '&meetingId=' +
    meetingId +
    '&userId=' +
    userInfo.userId +
    '@' +
    userInfo.domainName +
    '&type=' +
    type;
  return request(uri);
};
// 批量取消会议
export const cancelBatchMeeting = ({meetingIds, type, locale }) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  const uri =
    '/smartmeeting/smart/third/cancelBatchMeeting?lang=' +
    locale +
    '&meetingIds=' +
    meetingIds +
    '&userId=' +
    userInfo.userId +
    '@' +
    userInfo.domainName +
    '&type=' +
    type;
  return request(uri);
};
export const bookDel = ({ locale, meetingIds }) => {
  const url =
    '/smartmeeting/smart/third/deleteOwnMeeting?lang=' +
    locale +
    '&meetingIds=' +
    meetingIds;
  return request(url, { method: 'POST' });
};

//外部参会人
export const saveOrUpdateExternal = ({ external, locale }) => {
  let data = {};
  if (external.operator == 'save') {
    data.userName = external.userName;
    data.mobile = external.mobile;
    data.email = external.email;
  }
  let uri = '/iwork/external/saveUser?lang=' + locale;
  return request(uri, { method: 'POST', body: JSON.stringify(data) });
};

export const delayMeeting = ({ userId, meetingId, interval, locale }) => {
  const url = `/smartmeeting/smart/board/delay?lang=${locale}&meetingId=${meetingId}&userId=${userId}&interval=${interval}`;
  return request(url);
};

export const getMeetingAuditLogs = meetingId => {
  const url = `/smartmeeting/smart/third/getMeetingAuditLogs?meetingId=${meetingId}`;
  return request(url);
};
export const getSvcAuditLogs = meetingId => {
  const url = `/smartmeeting/smart/third/getSvcAuditLogs?meetingId=${meetingId}`;
  return request(url);
};
export const getBookingStatus = meetingId => {
  const url = `/smartmeeting/smart/third/getBookingStatus?meetingId=${meetingId}`;
  return request(url);
};



// WEBPACK FOOTER //
// ./src/services/meetingList.js